import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { cn } from "../../lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 overflow-hidden rounded-xl border border-border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      // Golden theme styles for tracker tooltips
      "bg-gradient-to-br from-amber-50/95 to-yellow-100/95 backdrop-blur-sm",
      "border-amber-200/60 shadow-lg shadow-amber-900/20",
      "text-amber-900 font-medium",
      "max-w-xs text-center leading-relaxed",
      className
    )}
    {...props}
  />
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

// Specialized TrackerTooltip for the golden theme used in trackers
const TrackerTooltip = React.forwardRef(({ className, sideOffset = 12, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    side="bottom"
    className={cn(
      // Very high z-index to appear above everything
      "z-[9999] overflow-hidden rounded-lg border px-3 py-2 text-xs shadow-xl animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      // Clean, compact golden design
      "bg-gradient-to-b from-amber-50 to-amber-100 border-amber-200",
      "text-amber-900 font-medium leading-tight",
      "max-w-xs text-left",
      // Arrow pointing up (tooltip appears below trigger)
      "relative",
      "before:content-[''] before:absolute before:top-[-6px] before:left-1/2 before:transform before:-translate-x-1/2",
      "before:border-l-[6px] before:border-r-[6px] before:border-b-[6px]",
      "before:border-l-transparent before:border-r-transparent before:border-b-amber-200",
      "after:content-[''] after:absolute after:top-[-5px] after:left-1/2 after:transform after:-translate-x-1/2",
      "after:border-l-[5px] after:border-r-[5px] after:border-b-[5px]",
      "after:border-l-transparent after:border-r-transparent after:border-b-amber-50",
      // Enhanced shadow and smooth transitions
      "shadow-lg shadow-amber-900/25 backdrop-blur-sm",
      "transition-all duration-150 ease-out",
      className
    )}
    {...props}
  />
))
TrackerTooltip.displayName = "TrackerTooltip"

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, TrackerTooltip }